
import React, { useEffect, useState } from "react";
import { baseURL } from "../../constants";

type propsData = {
    client: any;
}

function ClientImages({ client }: propsData) {

    const [showProfilePicture, setShowProfilePicture] = useState<any[]>([]);
    const [showPersonalLogo, setShowPersonalLogo] = useState<any[]>([]);
    const [showCompanyLogo, setShowCompanyLogo] = useState<any[]>([]);
    const [showAdditionalImage, setShowAdditionalImage] = useState<any[]>([]);

    useEffect( () => {
        if (client) {
            client.attachments.forEach((image: { id: number, url: string, attachmentType: string } ) => {
                if (image.attachmentType === "PROFILE_PICTURE") {
                    setShowProfilePicture((showProfilePicture: any[]) => { return [ ...showProfilePicture, image ] } )
                }
                else if (image.attachmentType === "PERSONAL_LOGO") {
                    setShowPersonalLogo((showPersonalLogo: any[]) => { return [ ...showPersonalLogo, image ] } )
                }
                else if (image.attachmentType === "COMPANY_LOGO") {
                    setShowCompanyLogo((showCompanyLogo: any[]) => { return [ ...showCompanyLogo, image ] } )
                }
                else {
                    setShowAdditionalImage((showAdditionalImage: any[]) => { return [ ...showAdditionalImage, image ] })
                }
            })
        }
    }, [client])

    return (
        <div
            className = "AddClientImages"
            style = {{
                padding: "0 100px 100px 100px",
            }}
        >
            <div className = "addClientImagesHead">
                <span>Profile Pictures</span>
                <span>Personal Logos</span>
                <span>Company Logos</span>
                <span>Additional Images </span>
            </div>
            <div className="allImagesBox">
                <div className="addClientPictureBox">
                    {
                        showProfilePicture!.map((picture: any, index: number) => {
                            return <div key = { index } className="addimageExampleBox">
                                <div className="concretImageBox">
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Profile Picture</span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img
                                            className = "addNewImage"
                                            src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture }
                                            alt = { "image" }
                                        />
                                    </div>
                                </div>
                                <div className="newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                    </span>
                                </div>
                            </div>
                        })
                    }
                </div>
                <div className="addClientPictureBox">
                    {
                        showPersonalLogo!.map((picture: any, index: number) => {
                            return <div key = { index } className = "addimageExampleBox">
                                <div className = "concretImageBox" key = { index }>
                                    <div className = "concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Personal Logo</span>
                                    </div>
                                    <div className = "concretImageNameBox">
                                        <img
                                            className = "addNewImage"
                                            src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture }
                                            alt = { "image" }
                                        />
                                    </div>
                                </div>
                                <div className = "newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                    </span>
                                </div>
                            </div>
                        })
                    }
                </div>
                <div className = "addClientPictureBox">
                    {
                        showCompanyLogo!.map((picture: any, index: number) => {
                                return <div key = { index } className = "addimageExampleBox">
                                    <div className = "concretImageBox" key = { index }>
                                        <div className = "concretImageButtonAndFotoBox">
                                            <span>{ index + 1 } Company Logo</span>
                                        </div>
                                        <div className="concretImageNameBox">
                                            <img
                                                className = "addNewImage"
                                                src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture }
                                                alt = { "image" }
                                            />
                                        </div>
                                    </div>
                                    <div className = "newImageNameAndDeleteBox">
                                        <span
                                            style = {{
                                                color: "#999",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                maxWidth: "85%",
                                                display: "inline-block",
                                            }}
                                        >
                                        </span>
                                    </div>
                                </div>
                            }
                        )
                    }
                </div>
                <div className = "addClientPictureBox">
                    {
                        showAdditionalImage!.map((picture: any, index: number) => {
                            return <div key = { index } className = "addimageExampleBox">
                                <div className = "concretImageBox" key = { index }>
                                    <div className = "concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Additional Image</span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img
                                            className = "addNewImage"
                                            src = { picture.id ? `${baseURL}/attachments?name=${picture.url}` : picture }
                                            alt = { "image" }
                                        />
                                    </div>
                                </div>
                                <div className = "newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                    </span>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default ClientImages;
